import React, { ReactNode } from 'react';
import BNNLogo from '../assets/bnnlogo.png';
import IndonesiaFlag from '../assets/indonesia.png';
import EnglishFlag from '../assets/english.png';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { generateDefaultScreenRoute } from '../utils/route';

interface LanguageSelectorProps {
  logo: ReactNode;
  text: string;
  isActive?: boolean;
  onClick: () => void;
}

function LanguageSelector({
  logo,
  text,
  isActive,
  onClick,
}: LanguageSelectorProps) {
  return (
    <div
      className={clsx(
        'border border-white py-14 px-18 rounded-full flex items-center space-x-8 font-semiBold cursor-pointer',
        {
          'bg-white text-darkBlue': isActive,
          'text-white hover:bg-white hover:text-darkBlue': !isActive,
        }
      )}
      onClick={onClick}
    >
      {logo}
      <div>{text}</div>
    </div>
  );
}

export default function Header() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const backToMainPage = () => {
    const defaultRoute = generateDefaultScreenRoute(
      parseInt(process.env.REACT_APP_DEFAULT_SCREEN, 10)
    );
    if (location.pathname !== defaultRoute) {
      navigate(defaultRoute);
    }
  };

  const currentLanguage = i18n.language;

  return (
    <div className="flex space-x-20 pb-20">
      <img
        className="w-[54px] h-[54px] cursor-pointer"
        src={BNNLogo}
        alt="bnn"
        onClick={backToMainPage}
      />
      <div className="flex space-x-8">
        <LanguageSelector
          logo={<img className="w-auto h-18" src={IndonesiaFlag} alt="flag" />}
          text="Indonesia"
          isActive={currentLanguage === 'id'}
          onClick={() => changeLanguage('id')}
        />
        <LanguageSelector
          logo={<img className="w-auto h-25" src={EnglishFlag} alt="flag" />}
          text="English"
          isActive={currentLanguage === 'en'}
          onClick={() => changeLanguage('en')}
        />
      </div>
    </div>
  );
}
